<template>
    <div>
        <p class="mt-3 font-medium text-gray-700">Sign up to accept the invite</p>
        <router-link tag="a" :to="{ name: 'signin', params: { redirectToPrevious: true } }" class="text-sm font-normal hover:underline text-primary-500">
            Already have an account?
        </router-link>
        <form @submit.prevent="registerAndAccept" class="items-center w-full mt-3">
            <p v-if="this.error != ''" class="flex justify-center py-2 text-sm font-semibold text-red-500">{{ error }}</p>
            <fieldset class="mb-3 form-group">
                <label class="block mb-1 text-sm font-semibold text-gray-700" for="full-name">
                    Full name
                </label>
                <input class="py-3 input focus:outline-none focus:border-gray-700" id="full-name" v-model="$v.full_name.$model" type="text" placeholder="First and last name" />
                <p v-if="$v.full_name.$error && !$v.full_name.required" class="py-2 text-sm font-semibold text-red-500">
                    Your full name is required
                </p>
            </fieldset>
            <fieldset class="mb-3 form-group">
                <label class="block mb-1 text-sm font-semibold text-gray-700" for="Email">Email</label>
                <input class="py-3 input focus:outline-none focus:border-gray-700" id="email" v-model="$v.email.$model" type="text" placeholder="Email" />
                <div v-if="$v.email.$error">
                    <p v-if="!$v.email.required" class="py-2 text-sm font-semibold text-red-500">
                        Your email is required
                    </p>
                    <p v-if="!$v.email.email" class="py-2 text-sm font-semibold text-red-500">
                        Your email format doesn't seem valid
                    </p>
                </div>
            </fieldset>
            <fieldset class="mb-4 form-group">
                <label class="block mb-1 text-sm font-semibold text-gray-700">Password</label>
                <input class="py-3 input focus:outline-none focus:border-gray-700" type="password" v-model="$v.password.$model" placeholder="Password" />
                <div v-if="$v.password.$error">
                    <p v-if="!$v.password.required" class="py-2 text-sm font-semibold text-red-500">
                        A password is required
                    </p>
                    <p v-if="!$v.password.minLength" class="py-2 text-sm font-semibold text-red-500">
                        Your password needs to be at least 6 characters
                    </p>
                </div>
            </fieldset>
            <loading-button type="submit" :loading="loading" :textColor="gray" class="w-full text-white bg-green-400 hover:bg-green-500 active:bg-green-400">
                Sign up and Accept
            </loading-button>
        </form>
        <div class="mt-4 text-sm text-gray-700">
            By clicking "Sign up and Accept" you agree to Flowist's
            <a class="underline" href="/legal#terms">Privacy Policy</a>
            and
            <a class="underline" href="/legal#privacy">Terms of Service</a>
            .
        </div>
    </div>
</template>

<script>
import LoadingButton from '@/components/LoadingButton';
import { required, minLength, email } from 'vuelidate/lib/validators';

export default {
    name: 'simple-signup-form',
    components: { LoadingButton },
    data() {
        return {
            loading: false,
            full_name: '',
            email: '',
            password: '',
            error: '',
            gray: 'text-gray-100',
        };
    },
    methods: {
        registerAndAccept() {
            const { full_name, email, password } = this;
            this.loading = true;
            if (this.$v.$invalid) {
                this.error = 'Please fill out all the information. This way we can setup your account correctly.';
            } else {
                this.$store
                    .dispatch('users/register_simple', {
                        token: this.$route.query.token,
                        user: {
                            full_name,
                            email: this.email.trim().toLowerCase(),
                            password,
                        },
                    })
                    .then(() => this.$emit('join'))
                    .catch(err => {
                        this.error = 'Hmm. Something went wrong in the signup.';
                        this.loading = false;
                    });
            }
        },
    },
    validations: {
        full_name: {
            required,
        },
        email: {
            required,
            email,
        },
        password: {
            required,
            minLength: minLength(6),
        },
    },
};
</script>
